import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { blogBySlug } from '../mdx/blogs';
import './BlogDetails.css';

const BlogDetails = () => {
  const { slug } = useParams();
  const post = blogBySlug[slug];

  if (!post) {
    return <section className="blog-details blog-details--not-found"><div className="blog-details-container"><div className="blog-details-not-found"><h2>Post not found</h2><p>The blog post you’re looking for doesn’t exist.</p><Link to="/moyer-blogs" className="back-link">← Back to Blogs</Link></div></div></section>;
  }

  const Content = post.Component;

  return (
    <section className="blog-details">
      <div className="blog-details-container">
        <Link to="/moyer-blogs" className="back-link">← Back to Blogs</Link>
        <article className="blog-article">
          <header className="blog-article-header">
            <h1 className="blog-article-title">{post.title}</h1>
            <div className="blog-article-meta"><span className="blog-article-date">{new Date(post.publishedAt).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}</span><span className="blog-article-dot">·</span><span className="blog-article-readtime">5 min read</span></div>
          </header>
          <div className="blog-article-image-container"><img src={post.featuredImage} alt={post.title} className="blog-article-image" /></div>
          <div className="blog-article-content"><div className="blog-article-body"><Content /></div><footer className="blog-article-footer"><div className="blog-article-tags"><span className="blog-article-tag">Blog</span><span className="blog-article-tag">{post.category}</span></div><div className="blog-article-actions"><button className="blog-article-action-btn" type="button" aria-label="Share article">Share</button></div></footer></div>
        </article>
      </div>
    </section>
  );
};

export default BlogDetails;
